import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const yahoo = defineConnector({
  identifier: "yahoo",
  name: "Yahoo",
  tagLine: "Web services platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ apiDomain }) => domainToRegex(apiDomain),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Yahoo instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Yahoo instance.",
        },
        {
          kind: "input",
          label: "API Domain",
          placeholder: "fantasysports.yahooapis.com",
          required: true,
          target: { kind: "configuration", field: "apiDomain" },
          helperText:
            "The domain to the API you want to connect to (e.g. https://fantasysports.yahooapis.com)",
        },
      ],
    },
    {
      title: "Create a Yahoo app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Yahoo Developer Portal](https://developer.yahoo.com/apps/) and create a new application to get your client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/yahoo/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Yahoo account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Yahoo account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://api.login.yahoo.com/oauth2/request_auth",
    tokenEndpoint: () => "https://api.login.yahoo.com/oauth2/get_token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) => `https://${configuration.apiDomain}/v1/me/guid`,
  },
  publicEnvVars: ({ apiDomain }) => ({
    YAHOO_API_URL: apiDomain ? `https://${apiDomain}` : "",
  }),
});
